export default "__VITE_ASSET__2VLgBWeH__"